import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { CloseButton, EmailMatch, EmailName, MatchIconCircle, TopContentWrapper } from 'Pages/directSurvey/style';
import { CLOSE_BUTTON, TOP_CONTENT } from 'Pages/directSurvey/testId';
import { ICON_IDS } from 'Shared/components/icons/constants';
import Icon from 'Shared/components/icons/icon';

/**
 * Renders the DSTopContent component
 */
function DSTopContent(): JSX.Element {
  const { t }     = useTranslation('app');
  const emailName = t('Email--direct-survey-name');

  return (
    <TopContentWrapper data-testid={TOP_CONTENT}>
      <EmailMatch>
        <MatchIconCircle>
          <Icon iconId={ICON_IDS.EMAIL_FILL} width={19} height={19} color='currentcolor' />
        </MatchIconCircle>
        <Trans t={t} i18nKey='Email--match' values={{ emailName }}>
          From your <EmailName>{emailName}</EmailName> email
        </Trans>
      </EmailMatch>
      <CloseButton to='/' data-testid={CLOSE_BUTTON}>
        <Icon iconId={ICON_IDS.CLOSE} width={24} height={24} />
      </CloseButton>
    </TopContentWrapper>
  );
}

export default DSTopContent;
